import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { IPrCustodyEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { SocialEventsFormViewForExtend } from "@pages/payroll/socialEvents/SocialEventsFormView";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class CustodyFormView extends SocialEventsFormViewForExtend<IPrCustodyEventEntity> {
    typeCode = PrSocialEventTypeCode.Custody;
}

export default withPermissionContext(withConfirmationDialog(CustodyFormView));